import React from 'react'
import Counter from '../home/counter/Counter'
import Download_free from '../home/download_free/Download_free'
import Customer_reviews from '../home/customer_reviews/Customer_reviews'
import Driven_By_Purpose from '../home/driven_by_purpose/Driven_By_Purpose'
import Common_breadcrumb from '../common_components/common-breadcrumb/Common_breadcrumb'
import About_content from './about_content/About_content'
import Why_Choose_Us from './why_Choose_Us/Why_Choose_Us'
import Download_Today from './download_Today/Download_Today'

function About_Us() {
    const breadcrumbsData = [
        { name: "HOMEPAGE", href: "/" },
        { name: "About US", active: true }
    ];

    return (
        <>
            <Common_breadcrumb
                pageName="About Us"
                bgImage="/assets/images/about_us/bg.png"
                breadcrumbs={breadcrumbsData}
            />
            <About_content />
            <Why_Choose_Us />
            <Driven_By_Purpose />
            <Download_Today />
            <Counter />
            {/* <Customer_reviews /> */}
        </>
    )
}

export default About_Us